import Vue from "vue";
import auth from "@core/auth";
import axios from "axios";
import router from "@/router";
import Toast from "vue-toastification";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

// Vue Toastification configuration
Vue.use(Toast, {
  hideProgressBar: true,
  closeOnClick: false,
  closeButton: false,
  icon: false,
  timeout: 3000,
  transition: "Vue-Toastification__fade",
});

const TOKEN_TYPE = "Bearer";
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL || "";
let isTokenRefreshing = false;
let subscribers = [];

function onTokenRefreshed(accessToken) {
  subscribers.forEach((callback) => callback(accessToken));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

async function refreshToken() {
  let refresh_Token = localStorage.getItem("refreshToken");
  if (refresh_Token) {
    if (!isTokenRefreshing) {
      isTokenRefreshing = true;
      try {
        const response = await axios.post("/Auth/RefreshToken", {
          refreshToken: refresh_Token,
        });
        auth.tokenManager(response.data);
        isTokenRefreshing = false;
        onTokenRefreshed(response.data.accessToken);
        subscribers = [];
        return response.data.accessToken;
      } catch (error) {
        isTokenRefreshing = false;
        subscribers = [];
        localStorage.clear();
        router.push("/login");
        throw error;
      }
    }
  }
  else {
    subscribers = [];
    localStorage.clear();
    router.push("/login");
  }
}

axios.interceptors.request.use(
  async (config) => {
    if (router.history.current.path !== "/login") {
      const accessToken = localStorage.getItem("accessToken");
      if (accessToken) {
        config.headers.common["Authorization"] = TOKEN_TYPE + " " + accessToken;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response == undefined) {
      Vue.$toast({
        component: ToastificationContent,
        props: {
          title: "خطا در برقراری ارتباط با سرور",
          icon: "BellIcon",
          variant: "danger",
        },
      });
    }
    const originalRequest = error.config;
    if (
      error.response.status === 401 &&
      !originalRequest._retry &&
      router.history.current.path !== "/login"
    ) {
      if (!isTokenRefreshing) {
        originalRequest._retry = true;
        try {
          const newToken = await refreshToken();
          axios.defaults.headers.common["Authorization"] =
            TOKEN_TYPE + " " + newToken;
          originalRequest.headers["Authorization"] =
            TOKEN_TYPE + " " + newToken;
          return axios(originalRequest);
        } catch (refreshError) {
          return Promise.reject(refreshError);
        }
      } else {
        return new Promise((resolve) => {
          addSubscriber((token) => {
            originalRequest.headers["Authorization"] = TOKEN_TYPE + " " + token;
            resolve(axios(originalRequest));
          });
        });
      }
    } else {
      if (error.response.status === 403) {
        router.push("/not-authorized");
      }
    }

    // Handle other errors
    if (error.response) {
      if (error.response.data.errors.length) {
        const errorDetails = error.response.data.errors[0].message;
        Vue.$toast({
          component: ToastificationContent,
          props: {
            title: errorDetails,
            icon: "BellIcon",
            variant: "danger",
          },
        });
      }
    }

    return Promise.reject(error);
  }
);

Vue.prototype.$http = axios;
export default axios;
